import { Button } from "@imagedesignai/neo";
import { useRef, useState } from "react";
import type { ShareLinkView } from "./api-client.ts";

export function ShareButton(props: {
  link: ShareLinkView | null;
  onPrepare(): Promise<ShareLinkView>;
  onShare(link: Promise<ShareLinkView>): void | Promise<void>;
}) {
  const isSharingRef = useRef(false);
  const [isSharing, setIsSharing] = useState(false);

  const share = async () => {
    if (isSharingRef.current) return;
    isSharingRef.current = true;
    setIsSharing(true);
    try {
      const link = props.link ? Promise.resolve(props.link) : props.onPrepare();
      await props.onShare(link);
    } catch {
      // The owning callbacks surface preparation and copy failures.
    } finally {
      isSharingRef.current = false;
      setIsSharing(false);
    }
  };

  return (
    <Button
      intent="secondary"
      size="sm"
      icon="share-2"
      loading={isSharing}
      onClick={() => void share()}
    >
      Share
    </Button>
  );
}
